import React from "react";

const refs = React.createContext();

export default refs;
